import useSWRMutation, { type SWRMutationConfiguration } from 'swr/mutation';

import {
  putReadMessages,
  type PutReadMessagesParams,
  type PutReadMessagesResponse,
} from '@services/MatchesService';

export type UsePutReadMessagesParams = PutReadMessagesParams & {
  mutationOptions?: SWRMutationConfiguration<
    PutReadMessagesResponse,
    unknown,
    string,
    never,
    PutReadMessagesResponse
  >;
};

export const putReadMessagesMutationKey = (matchId: string) =>
  `put-read-messages-${matchId}`;

export const usePutReadMessages = ({
  matchId,
  mutationOptions,
}: UsePutReadMessagesParams) => {
  const { trigger, ...swrResponse } = useSWRMutation<
    PutReadMessagesResponse,
    unknown,
    string,
    never
  >(
    putReadMessagesMutationKey(matchId),
    () => putReadMessages({ matchId }),
    mutationOptions,
  );

  return {
    trigger,
    ...swrResponse,
  };
};
